import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
	palette: {
		primary: { main: '#295C81' },
	},
	breakpoints: {
		values: {
		//   xxs: 0, // smol phone
		  xs: 300, // phone
		  sm: 600, // tablets
		  md: 900, // small laptop
		  lg: 1200, // desktop
		  xl: 1536 // large screens
		}
	  }
})
